module.exports = __webpack_public_path__ + "static/media/Icono empresa.f1b24141.svg";